import script from "./ComLisaaOikeus.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComLisaaOikeus.vue?vue&type=script&setup=true&lang=ts"

import "./ComLisaaOikeus.vue?vue&type=style&index=0&id=a906fad0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a906fad0"]])

export default __exports__